import { Typography, Button, CircularProgress } from '@mui/material';
import styled from '@emotion/styled';
import { isEqual } from 'lodash';
import AccessControlService from '../services/api/access-control-service';
import { useEffect, useState } from 'react';

// Create a styled button with a gradient background
const GradientButton = styled(Button)(({ theme }) => ({
    position: 'fixed', // Make the button float
    top: '100px',    // Distance from the bottom of the viewport
    right: '45px',     // Distance from the right side of the viewport
    background: 'linear-gradient(45deg, #604CC3 30%, #8C6BD9 90%)', // Gradient related to #604CC3
    borderRadius: '30px', // Rounded corners
    color: 'white',
    height: '48px',
    padding: '0 30px',
    boxShadow: '0 3px 5px 2px rgba(96, 76, 195, .3)',
    '&:hover': {
        background: 'linear-gradient(45deg, #8C6BD9 30%, #604CC3 90%)', // Hover effect
    },
}));


const SavePermission = ({row, setCurrentPermission, currentPermission = [], permissionList = [], enqueueSnackbar}) => {

    const [loading, setLoading] =  useState(false);

    useEffect(() => {
        if(JSON.stringify(permissionList.sort((a, b) => a.id - b.id)) === JSON.stringify(currentPermission.sort((a, b) => a.id - b.id)) ) {
            setLoading(false)
        }
    }, [currentPermission, permissionList]);

    const handleOnClick = () => {
        setLoading(true)
        // Get added permissions
        const addedPermissions = permissionList.filter(
            newPerm => !currentPermission.some(currentPerm => isEqual(newPerm, currentPerm))
        );
        console.log("addedPermissions", addedPermissions)
        addedPermissions.forEach(permission => {
            console.log(`ID: ${permission.id}, Function: ${permission.fn}`);
            let payload = {
                "role_id": row.id,
                "permission_id": permission.id
            }
            AccessControlService.addRoleAccess(payload).then((res) => {
                let apiResponse = res.data;
                console.log("addRoleAccess", apiResponse)

                const permissionSelected = {
                    id: permission.id,
                    fn: permission.fn
                }
                setCurrentPermission(prevList => [...prevList, permissionSelected]);

            }).catch((error) => {
                const errorMessage = error?.response?.data?.error || error.message;
                enqueueSnackbar(errorMessage, {
                    variant: "error",
                    autoHideDuration: 2000
                })
            })
        });

        // Get removed permissions
        const removedPermissions = currentPermission.filter(
            currentPerm => !permissionList.some(newPerm => isEqual(currentPerm, newPerm))
        );
        console.log("removedPermissions", removedPermissions)
        removedPermissions.forEach(permission => {
            console.log(`ID: ${permission.id}, Function: ${permission.fn}`);
            let parameters = {
                "roleId": row.id,
                "permissionId": permission.id
            }
            AccessControlService.removetRoleAccess(parameters).then((res) => {
                let apiResponse = res.data;
                console.log("removetRoleAccess", apiResponse)

                const permissionSelected = {
                    id: permission.id,
                    fn: permission.fn
                }
                setCurrentPermission(prevList => prevList.filter(p => p.id !== permissionSelected.id));

            }).catch((error) => {
                const errorMessage = error?.response?.data?.error || error.message;
                enqueueSnackbar(errorMessage, {
                    variant: "error",
                    autoHideDuration: 2000
                })
            })
        });
    }

    return (
          <div>
                {loading && (
                    <Typography
                            variant="h6"
                            sx={{
                                position: 'fixed',  // Makes it float
                                top: "100px",         // Distance from the bottom
                                right: "45px",          // Distance from the right
                                background: 'linear-gradient(90deg, #2196F3, #21CBF3)',
                                color: '#fff',      // Text color
                                padding: '8px 16px', // Padding for the text
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                fontWeight: 'bold',  // Optional: makes the text bolder
                                fontSize: '0.875rem'
                            }}
                        >
                        <CircularProgress size={15} /> Saving Changes...
                </Typography>
                )}
                {!loading &&  JSON.stringify(permissionList.sort((a, b) => a.id - b.id)) !== JSON.stringify(currentPermission.sort((a, b) => a.id - b.id)) ? (
                    <GradientButton onClick={handleOnClick} variant="contained">Save Changes</GradientButton>
                ): (
                    <div>
                        {!loading && (
                            <Typography
                                variant="h6"
                                sx={{
                                    position: 'fixed',  // Makes it float
                                    top: "100px",         // Distance from the bottom
                                    right: "45px",          // Distance from the right
                                    background: 'linear-gradient(90deg, #00C853, #B2FF59)',
                                    color: '#fff',      // Text color
                                    padding: '8px 16px', // Padding for the text
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    fontWeight: 'bold',  // Optional: makes the text bolder
                                    fontSize: '0.875rem'
                                }}
                            >
                                Role permissions were synced!
                            </Typography>
                        )}
                    </div>
                )}
          </div>
    )

}

export default SavePermission;